<template>
  <div id="verify-match-step-right-part" class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0">
    <div id="verify-match-step-right-part-inside" class="w-100">
      <div class="col-12 pl-0 pr-0 mb-1">
        <b-form-group
          :label="$t('annonce.vehicle.need.image')"
          label-for="vehicleFiles-input"
          :invalid-feedback="imagesVehicleState.invalidFeedback"
          :state="imagesVehicleState.state"
          class="small-text">
          <b-form-file
            ref="vehicleFiles-input"
            id="vehicleFiles-input"
            :browse-text="$t('Select')"
            placeholder=""
            multiple
            @input="setVehicleFiles($event)"
            :drop-placeholder="$t('drop-placeholder')"
            required
            accept=".png, .jpeg, .jpg">
          </b-form-file>
        </b-form-group>
      </div>
      <PreviewSeveralImages fileId="recto" :files="vehicleFiles" @deleteFileInPreview="deleteFile"></PreviewSeveralImages>
    </div>
  </div>
</template>

<script>
import i18n from "../../i18n";
import PreviewSeveralImages from "../../components/b122/showFields/PreviewSeveralImages";

export default {
  name: "VerifyMatchStep1",

  components: {
    PreviewSeveralImages,
  },

  props:{
    'vehicleFilesSaved': Array,
    'imageInvalidState': Boolean
  },

  emits:["updateSelectedPhotos"],

  data(){
    return {
      vehicleFiles : [],
      imagesVehicleState:{
        state: null,
        invalidFeedback: null,
        value: null
      },
    }
  },

  mounted(){
    this.vehicleFiles = this.$props.vehicleFilesSaved.map(file => {
      if(file.id){
        return {...file,url:`${this.getFileUrl(file.fileUrl)}`}
      }
      else{
        return {...file}
      }
    })
  },

  watch:{
    'imageInvalidState': {
      immediate:true,
      handler () {
        if(this.$props.imageInvalidState === false){
          this.imagesVehicleState.state = false
          this.imagesVehicleState.invalidFeedback = this.$i18n.t('MandatoryField')
        }
      }
    }
  },


  methods:{
    setVehicleFiles(event){
      if(event){
        event.forEach(file => {
          const fileUrl = URL.createObjectURL(file)
          this.vehicleFiles.push({ url: fileUrl, file: file })
          this.imagesVehicleState.state = null
          this.imagesVehicleState.invalidFeedback = null
        })
      }
      this.$refs['vehicleFiles-input'].reset()
      this.$emit('updateSelectedPhotos', this.vehicleFiles)
    },

    getFileUrl(path) {
      return (window.location.hostname === "integration-grand-public-lamp.bleu122.com" ? "https://integration-lamp.bleu122.com" : process.env.SERVER_URL) + path
    },

    deleteFile(index){
      this.vehicleFiles.splice(index,1)

      this.imagesVehicleState.state = null
      this.imagesVehicleState.invalidFeedback = null

      this.$emit('updateSelectedPhotos', this.vehicleFiles)
    },

    // onFileInputChange() {
    //   const maxFilesAllowed = 3;
    //   const files = this.vehicleFiles;
    //   if (files && files.length > maxFilesAllowed) {
    //     this.vehicleFiles = files.slice(0, maxFilesAllowed);
    //   }
    // }

  },
}
</script>

<style scoped>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {
  #verify-match-step-right-part {
    height: 100%;
    overflow: auto;
  }
  #verify-match-step-right-part-inside {
    padding-left: 3px; /* pour voir le border sur les input focus */
    width: 100%;
    margin-bottom: auto; /* si il n'y a pas assez d'items pour remplir la hauteur */
  }
}

.custom-span-img{
  font-size: 14px;
  font-weight: 500;
  display: block;
  color: var(--main-grey-medium);
}

</style>



// WEBPACK FOOTER //
// src/views/match/VerifyMatchStep1.vue